<div *ngIf="orgName" class="card shadow-sm rounded-4 border-0 mb-3" style="background: #f8fafc;">
  <div class="card-body py-3 px-4">
    <h6 class="mb-0 text-primary" style="font-size: 1rem; color:#296fab !important;font-weight: 600;">
      Parent Organization: {{ orgName }}
    </h6>
  </div>
</div>

<div class="row g-4 justify-content-center">
  <div class="col-12 col-md-6 col-lg-4" *ngFor="let setting of settingsConfig">
    <div class="tile-widget-card position-relative overflow-hidden">
      <div class="tile-accent-bar" [ngClass]="setting.icon?.includes('shield') ? 'bg-primary' : 'bg-primary'"></div>
      <div class="card-body p-4 d-flex flex-column h-100">
        <div class="mb-3">
          <div *ngIf="alerts[setting.id]">
            <div *ngIf="alerts[setting.id]?.type === 'success'" class="alert alert-success py-2 px-3 mb-2 w-100"
              role="alert" style="font-size:1.05rem;">
              {{ alerts[setting.id]?.message }}
            </div>
            <div *ngIf="alerts[setting.id]?.type === 'error'" class="alert alert-danger py-2 px-3 mb-2 w-100"
              role="alert" style="font-size:1.05rem;">
              {{ alerts[setting.id]?.message }}
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <h5 class="card-title mb-1 fw-semibold tile-title me-2">{{ setting.label }}</h5>
              <!-- Checkbox beside the title, no label -->
              <ng-container *ngIf="setting.id !== 'passwordMinLength'">
                <input type="checkbox"
                  [(ngModel)]="settingEnabled[setting.id]"
                  class="form-check-input ms-1"
                  id="enable-{{setting.id}}">
              </ng-container>
            </div>
          </div>
        </div>
        <!-- Special rendering for passwordResetEmail: only description, no input -->
        <ng-container *ngIf="setting.id === 'passwordResetEmail'; else normalSetting">
          <div class="d-flex align-items-center mb-2 gap-3 tile-input-row">
            <span class="form-text text-muted tile-desc mb-0">{{ setting.description }}</span>
          </div>
        </ng-container>
        <ng-template #normalSetting>
          <!-- Special rendering for accountLocking: two inputs between heading and description -->
          <div *ngIf="setting.id === 'accountLocking'; else defaultInputs">
            <div class="d-flex align-items-center mb-2 gap-3 tile-input-row">
              <label class="mb-0 me-2">failed:</label>
              <input #attemptsRef type="number"
                [min]="setting.attemptsDropdown ? setting.attemptsDropdown[0] : 1"
                [max]="setting.attemptsDropdown ? setting.attemptsDropdown[setting.attemptsDropdown.length - 1] : 10"
                [step]="1"
                [(ngModel)]="settingValues['lockAccountAttempts']"
                (input)="clampSettingValue({min: setting.attemptsDropdown ? setting.attemptsDropdown[0] : 1, max: setting.attemptsDropdown ? setting.attemptsDropdown[setting.attemptsDropdown.length - 1] : 10, id: 'lockAccountAttempts'}, $event, attemptsRef)"
                (blur)="
                  settingValues['lockAccountAttempts'] = 
                    settingValues['lockAccountAttempts'] === '' ? (setting.attemptsDropdown ? setting.attemptsDropdown[0] : 1) :
                    settingValues['lockAccountAttempts'] < (setting.attemptsDropdown ? setting.attemptsDropdown[0] : 1) ? (setting.attemptsDropdown ? setting.attemptsDropdown[0] : 1) :
                    settingValues['lockAccountAttempts'] > (setting.attemptsDropdown ? setting.attemptsDropdown[setting.attemptsDropdown.length - 1] : 10) ? (setting.attemptsDropdown ? setting.attemptsDropdown[setting.attemptsDropdown.length - 1] : 10) :
                    settingValues['lockAccountAttempts'];
                  attemptsRef.value = settingValues['lockAccountAttempts'];
                "
                class="form-control form-control-lg shadow-sm border-0 px-2 py-1 fancy-input"
                style="width: 80px;"
                [disabled]="!settingEnabled[setting.id]">
              <span class="ms-1">attempts</span>
              <span class="ms-3">within:</span>
              <input #timeRef type="number"
                [min]="setting.timeDropdown ? setting.timeDropdown[0] : 1"
                [max]="setting.timeDropdown ? setting.timeDropdown[setting.timeDropdown.length - 1] : 60"
                [step]="1"
                [(ngModel)]="settingValues['lockAccountTime']"
                (input)="clampSettingValue({min: setting.timeDropdown ? setting.timeDropdown[0] : 1, max: setting.timeDropdown ? setting.timeDropdown[setting.timeDropdown.length - 1] : 60, id: 'lockAccountTime'}, $event, timeRef)"
                (blur)="
                  settingValues['lockAccountTime'] = 
                    settingValues['lockAccountTime'] === '' ? (setting.timeDropdown ? setting.timeDropdown[0] : 1) :
                    settingValues['lockAccountTime'] < (setting.timeDropdown ? setting.timeDropdown[0] : 1) ? (setting.timeDropdown ? setting.timeDropdown[0] : 1) :
                    settingValues['lockAccountTime'] > (setting.timeDropdown ? setting.timeDropdown[setting.timeDropdown.length - 1] : 60) ? (setting.timeDropdown ? setting.timeDropdown[setting.timeDropdown.length - 1] : 60) :
                    settingValues['lockAccountTime'];
                  timeRef.value = settingValues['lockAccountTime'];
                "
                class="form-control form-control-lg shadow-sm border-0 px-2 py-1 fancy-input"
                style="width: 80px;"
                [disabled]="!settingEnabled[setting.id]">
              <span class="ms-1">min</span>
            </div>
            <div class="form-text text-muted mt-2 tile-desc">{{ setting.description }}</div>
          </div>
          <ng-template #defaultInputs>
            <div class="d-flex align-items-center mb-2 gap-3 tile-input-row">
              <input #inputRef type="number"
                [min]="setting.min"
                [max]="setting.max"
                [step]="setting.step"
                [(ngModel)]="settingValues[setting.id]"
                (input)="clampSettingValue(setting, $event, inputRef)"
                (blur)="
                  settingValues[setting.id] = 
                    settingValues[setting.id] === '' ? setting.min :
                    settingValues[setting.id] < setting.min ? setting.min :
                    settingValues[setting.id] > setting.max ? setting.max :
                    settingValues[setting.id];
                  inputRef.value = settingValues[setting.id];
                "
                class="form-control form-control-lg shadow-sm border-0 px-3 py-2 fancy-input tile-input"
                [ngClass]="setting.icon?.includes('shield') ? 'border-info' : 'border-primary'"
                [disabled]="setting.id !== 'passwordMinLength' && !settingEnabled[setting.id]">
              <span *ngIf="setting.unit" class="card-subtitle text-muted tile-unit ms-2">{{ setting.unit }}</span>
            </div>
            <div class="form-text text-muted mt-2 tile-desc">{{ setting.description }}</div>
          </ng-template>
        </ng-template>
        <button class="btn btn-gradient px-4 py-2 fancy-save-btn tile-save-btn position-absolute"
        [ngClass]="setting.icon?.includes('shield') ? 'btn-info' : 'btn-primary'"
        (click)="updateSetting(setting.id)"
        [disabled]="
          (setting.id !== 'passwordMinLength' && !settingEnabled[setting.id]) ||
          (
            setting.id === 'accountLocking'
              ? (
                  (settingValues['accountLockingAttempts'] < (setting.attemptsDropdown ? setting.attemptsDropdown[0] : 1) ||
                   settingValues['accountLockingAttempts'] > (setting.attemptsDropdown ? setting.attemptsDropdown[setting.attemptsDropdown.length - 1] : 10) ||
                   settingValues['accountLockingTime'] < (setting.timeDropdown ? setting.timeDropdown[0] : 1) ||
                   settingValues['accountLockingTime'] > (setting.timeDropdown ? setting.timeDropdown[setting.timeDropdown.length - 1] : 60)
                  )
                )
              : (
                  setting.min !== undefined && setting.max !== undefined &&
                  (settingValues[setting.id] < setting.min || settingValues[setting.id] > setting.max)
                )
          )
        ">
        <span class="d-flex align-items-center gap-2">
          <i class="bi bi-check-circle"></i> Save
        </span>
      </button>
      </div>
    </div>
  </div>
</div>